exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3QxWY{position:relative;font-weight:400;padding:8px 18px 10px}.yLFXk{font-size:17px;font-weight:700;margin:0 0 12px}._2jDVd{border-top:1px solid #ededed;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;min-height:55px;padding:8px 0}._2jDVd:first-of-type{border:none}._3quCg{font-size:14px;font-weight:700;padding-bottom:6px;display:block}._3quCg,.tcngL{color:#000;text-decoration:none}.tcngL{position:relative;display:inline-block;border:1px solid #ccc;border-radius:2px;font-size:12px;font-weight:400;text-align:center;padding:6px 10px;margin-top:15px;cursor:pointer}.tcngL:hover{border:1px solid #2196f3}._2jDVd:hover ._3quCg{color:#e73232}", ""]);

// exports
exports.locals = {
	"root": "_3QxWY",
	"title": "yLFXk",
	"spare": "_2jDVd",
	"spareTitle": "_3quCg",
	"allSpares": "tcngL"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/AutobookingForm/AutobookingAdvert.css
// module id = 1886
// module chunks = 0 15 17 22 36